import MojitoCore from 'mojito/core';
import DataProvidersTypes from 'services/sports-content/content-provider/types.js';

const DataProvider = MojitoCore.Services.DataProvider;
const {
    MarketProvider: { COLLECTION_NAME },
} = DataProvidersTypes;

/**
 * Class offering the possibility to link to event markets.
 *
 * @class MarketProvider
 * @extends Mojito.Core.Services.DataProvider
 * @memberof Mojito.Services.SportsContent.DataProviders
 */
class MarketProvider extends DataProvider {
    init(languageCode) {
        super.addSimpleCollection(COLLECTION_NAME, languageCode);
    }

    subscribeToEntity(marketId, onUpdate) {
        return super.subscribeToEntity(marketId, onUpdate, COLLECTION_NAME);
    }

    subscribeToEntities(marketIds, onInit, onUpdate) {
        return super.subscribeToEntities(marketIds, onInit, onUpdate, COLLECTION_NAME);
    }
}

export default new MarketProvider();
